export const publisherGroups: Record<string, string> = {
  All: '0',
  Advon: '1',
  PubX: '2',
};
